<template>
    <div>
        <div>
            <b-form-select v-model="selected" :options="options" class="select"></b-form-select>
            <div v-show="selected">Członkowie grupy: ({{setNumber}})</div>
            <div v-show="selected">
                <b-button v-on:click="showGroupUsers" class="show">{{buttonLabel}}</b-button>
                <div class="showGroups">
                    <div v-for="user in users" :key="user._id">
                        <p v-if="user.groups.includes(selected) && showUsers">{{user.lastName}} {{user.firstName}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {path} from '../../../config';
export default {
    name: 'targetGroup',
    created: async function() {
        await axios
            .get(`${path}groups`)
            .then(response => (
                this.groups = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            this.setLevels();
        await axios
            .get(`${path}users`)
            .then(response => (
                this.users = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
    },
    updated: function(){
        this.$emit('sendGroup', this.selected)
    },
    computed: {
        setNumber: function(){
            let usersArray = []
            for(let user of this.users){
                if(user.groups.includes(this.selected)){
                    usersArray.push(user)
                }
            }
            this.$emit('usersNumber', usersArray.length)
            return usersArray.length;
        }
    },
    methods: {
        setLevels: async function(){
            for(let item of this.groups){
                await this.options.push({value: item.name, text: item.name})
            }
        },
        showGroupUsers: function(){
            if(this.buttonLabel === 'Pokaż pracowników'){
                this.buttonLabel = 'Ukryj pracowników';
            } else{
                this.buttonLabel = 'Pokaż pracowników';
            }
            this.showUsers = !this.showUsers
            
        }
    },
    data: function(){
        return{
            selected: '',
            groups: '',
            users: '',
            showUsers: false,
            options: [
                {value: '', disabled: true, text: 'Wybierz grupę docelową'},
            ],
            buttonLabel: 'Pokaż pracowników',
        }
    }
}
</script>
<style lang="scss" scoped>
    .select {
        margin-bottom: 10px;
    }
    .showGroups {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        margin: 5px 0;
        p{
            margin: 0 5px;
            padding: 0 5px;
            border: solid;
            border-width: 1px;
        }
    }
    .show {
        background-color: green;
        border-radius: 10px;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(101, 168, 0);
        }
        &:focus{
            background-color: green;
            border: none;
            box-shadow: none;
        }
    }
</style>